import { CosignaturePermissionMetadata } from "@/core/types";
import { Heading2 } from "@/ui2/atoms/Heading";

type AssignedSupervisorProps = {
  assignedSupervisorName: CosignaturePermissionMetadata["assigned_supervisor_name"];
};

export function AssignedSupervisor({ assignedSupervisorName }: AssignedSupervisorProps) {
  return (
    <div className="body-sm tw:flex tw:flex-col tw:gap-1">
      <Heading2 as="h3" size={1}>
        Assigned Supervisor
      </Heading2>

      <p className="body-md">{assignedSupervisorName}</p>
    </div>
  );
}
